import React from 'react';

// 連携完了直後の数値反映タイミングの注記。
// 売上は連携時に即時取り込みをキックする。広告データは1日1回・早朝の定期取込のみ。
export default function DataSyncDelayNote() {
  return (
    <div className="alert alert-info small">
      <div className="fw-bold mb-1">
        <span className="fas fa-info-circle me-1" />
        連携完了後の数値の反映について
      </div>
      <ul className="mb-0 ps-3">
        <li>売上などのデータは連携時に自動で取り込みを開始します。反映まで少し時間がかかることがあります。</li>
        <li>広告データ（Amazon広告・楽天RPP）は1日1回・早朝に取り込まれるため、連携の翌朝以降に反映されます。</li>
      </ul>
    </div>
  );
}
